/**
 * Builds a display name from the optional first/last name pair returned by the
 * project summary endpoint. Names are nullable there because the member who
 * created a ticket or changed its status may since have been removed.
 */
export function summaryPersonName(firstName: string | null, lastName: string | null): string {
  const name = `${firstName ?? ""} ${lastName ?? ""}`.trim();
  return name === "" ? "Unknown user" : name;
}

/**
 * Shortens a member's name for the member activity chart's x-axis, e.g.
 * "Harry Buxton" becomes "Harry B.". Falls back to whichever part is present.
 */
export function summaryPersonShortName(firstName: string | null, lastName: string | null): string {
  const first = firstName?.trim();
  const last = lastName?.trim();

  if (first && last) return `${first} ${last[0]}.`;
  if (first) return first;
  if (last) return last;

  return "Unknown";
}
